import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { SortingState, Updater } from "@tanstack/react-table";

import { DataTableSorting } from "./types";

/** Reads and writes DRF-style `?ordering=-field` for server-side sorting. */
export const useUrlSorting = (param = "ordering"): DataTableSorting => {
  const [searchParams, setSearchParams] = useSearchParams();
  const ordering = searchParams.get(param);

  const state = useMemo<SortingState>(() => {
    if (!ordering) return [];
    const desc = ordering.startsWith("-");
    return [{ id: desc ? ordering.slice(1) : ordering, desc }];
  }, [ordering]);

  const onChange = useCallback(
    (updater: Updater<SortingState>) => {
      const next = typeof updater === "function" ? updater(state) : updater;
      const params = new URLSearchParams(searchParams);
      const [sort] = next;
      if (sort) params.set(param, `${sort.desc ? "-" : ""}${sort.id}`);
      else params.delete(param);
      params.delete("page");
      setSearchParams(params);
    },
    [param, searchParams, setSearchParams, state],
  );

  return { state, onChange };
};
